import { centerOf } from "./domHelpersService";
import timelineRandomVisualEffectService from "./timelineRandomVisualEffectService";

const CLOSE_GLIDE_MS = 600;

export function glideIconToMomentCenter(
  icon: HTMLElement,
  momentEl: HTMLElement,
  duration = 600
) {
  icon.style.transition =
    "left .6s cubic-bezier(.22,.61,.36,1), top .6s cubic-bezier(.22,.61,.36,1)";
  icon.style.position = "fixed";
  icon.style.opacity = "1";
  icon.style.display = "inline-block";

  const { x, y } = centerOf(momentEl);
  requestAnimationFrame(() => {
    icon.style.left = `${Math.round(x)}px`;
    icon.style.top = `${Math.round(y)}px`;
  });

  return new Promise<void>((resolve) => {
    const done = () => {
      icon.removeEventListener("transitionend", done);
      resolve();
    };
    icon.addEventListener("transitionend", done, { once: true });
    setTimeout(done, duration + 80);
  });
}

export function randomizeIconPositions() {
  document.querySelectorAll<HTMLElement>(".timeline-icon").forEach((icon) => {
    icon.style.left =
      timelineRandomVisualEffectService.getRandomFullWidthPosition() + "px";
    icon.style.top =
      timelineRandomVisualEffectService.getRandomTopPosition() + "px";
  });
}

export function setRandomFadePositionOnAllIcons() {
  document.querySelectorAll<HTMLElement>(".timeline-icon").forEach((icon) => {
    const isInOpenEpoch = !!icon.closest(".epoch--is-open .moment");
    if (isInOpenEpoch) { return; }

    const epochId = icon.dataset.epochid;
    if (!epochId) { return; }

    icon.dataset.fadeposition = String(
      timelineRandomVisualEffectService.getRandomFadePosition(
        epochId,
        window.innerHeight * 0.2
      )
    );
  });
}

export function fadeTimelineIcons() {
  document.querySelectorAll<HTMLElement>(".timeline-icon").forEach((icon) => {
    const isInOpenOrOpeningEpoch = !!icon.closest(
      ".epoch--is-open .moment, .epoch--is-opening .moment"
    );

    if (isInOpenOrOpeningEpoch || icon.dataset.gliding === "1") {
      icon.style.opacity = "1";
      icon.style.display = "inline-block";
      return;
    }

    const fadePos = Number(icon.dataset.fadeposition ?? 0);
    const diff = Math.abs(window.scrollY - fadePos);
    const opacity = Math.round((25 / (diff + 25)) * 1000) * 0.001;

    if (opacity < 0.026) {
      icon.style.display = "none";
    } else {
      icon.style.opacity = opacity.toString();
      icon.style.display = "block";
    }
  });
}

export function fadeTimeline() {
  const windowHeight = window.innerHeight;
  const centerY = windowHeight * 0.5;

  document.querySelectorAll<HTMLElement>(".epoch").forEach((epochElement) => {
    const text = epochElement.querySelector(
      ".epoch__text h2"
    ) as HTMLElement | null;
    const button = epochElement.querySelector(
      ".epoch__toggle-btn"
    ) as HTMLElement | null;

    if (!text || !button) { return; }

    const rect = epochElement.getBoundingClientRect();
    const elementCenter = rect.top + rect.height / 2;
    const distanceFromCenter = Math.abs(centerY - elementCenter);
    const fadeRange = windowHeight * 0.6;
    const opacity = Math.max(0, 1 - distanceFromCenter / fadeRange);

    text.style.opacity = opacity.toString();
    button.style.opacity = opacity.toString();
  });
}

export const ICON_CLOSE_GLIDE_MS = CLOSE_GLIDE_MS;